export default "__VITE_ASSET__CnCyIXH5__"